import React, { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export const Container: React.FC<Props> = ({ children }) => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-row gap-32 max-w-7xl w-full self-center pt-16 pb-16 px-4">
        {children}
      </div>
    </div>
  )
}
